import { Users } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

interface PrivatePollBadgeProps {
  className?: string;
}

export function PrivatePollBadge({ className }: PrivatePollBadgeProps) {
  return (
    <Badge 
      variant="secondary" 
      className={cn(
        "bg-violet-500/20 text-violet-600 dark:text-violet-400 border-violet-500/30 gap-1",
        className
      )}
    >
      <Users className="w-3 h-3" />
      Friends only
    </Badge>
  );
}
